import { DistributorsItems, DistributorsTitle } from "./constants";

function List(props) {
  const center = props.center;
  const markers = props.markers;
  const latitude = center.lat;
  const longitude = center.lng;
  const ZoneId = props.ZoneId;

  if (!markers) {
    return <></>
  }

  const filteredData = filtered(latitude, longitude, markers);

  // Traducción tiendas más cercanas
  const urlParams = new URLSearchParams(window.location.search);
  const lang = urlParams.get("lang") ? urlParams.get("lang") : "es";
  const closestShopsES = "Tiendas más cercanas";
  const closestShopsCA = "Botigues més properes";
  const closestShopsEN = "Closest stores";
  const closestShopsFR = "Magasins les plus proches";
  const closestShopsIT = "Negozi più vicini";
  const closestShopsDE = "Nächstgelegene Geschäfte";
  let closestShops = "";

  if (lang === "es") {
    closestShops = closestShopsES;
  } else if (lang === "ca") {
    closestShops = closestShopsCA;
  } else if (lang === "it") {
    closestShops = closestShopsIT;
  } else if (lang === "fr") {
    closestShops = closestShopsFR;
  } else if (lang === "de") {
    closestShops = closestShopsDE;
  } else {
    closestShops = closestShopsEN;
  }

  return (
    <div className="listing-store">
      <h3 className="title-listing">{closestShops}</h3>
      {ZoneId.length > 0 ? <div className="additional-info border-item">
        <h4 className="title-info">{DistributorsTitle}</h4>
        {DistributorsItems.filter(x => x.zoneId === ZoneId).map((item) => {
          return <div key={item.id}>
            <h4 className="subtitle-info">{item.name}</h4>
            <a href={item.url} className="subtitle-info link-info" target="_blank" rel="noreferrer">{item.url}</a>
          </div>
        })}
      </div> : <></>}
      <ul className="listing">
        {filteredData && filteredData.map(
          (item) => (
            <div className="item-store" key={item.Code}>
              <h4>{item.Name}</h4>
              <h4 className="address-info">{item.Address + ", " + item.PostalCode + ", " + item.City}</h4>
              <h4 className="address-info">{item.Phone}</h4>
              <button
                className="button"
                onClick={() =>
                  props.store({
                    Code: item.Code,
                    Name: item.Name,
                    Phone: item.Phone,
                    Longitude: item.Longitude,
                    Latitude: item.Latitude,
                    Address: item.Address,
                    City: item.City,
                    PostalCode: item.PostalCode
                  })
                }
              >
                View on map
              </button>
            </div>
          )
        )}
      </ul>
    </div>
  );
}

function filtered(latitude, longitude, markers) {
  var list = [];
  for (let i = 0; i < markers.length; i++) {
    var distance = Math.sqrt(
      Math.pow(latitude - markers[i].Latitude, 2) +
      Math.pow(longitude - markers[i].Longitude, 2)
    );
    list.push({
      distance: distance,
      Code: markers[i].Code,
      Name: markers[i].Name,
      Phone: markers[i].Phone,
      Longitude: markers[i].Longitude,
      Latitude: markers[i].Latitude,
      Address: markers[i].Address,
      City: markers[i].City,
      PostalCode: markers[i].PostalCode
    });
  }
  list.sort(function (a, b) {
    return a.distance - b.distance;
  });
  var list10 = [];
  for (let i = 0; i < 10; i++) {
    if (list.length > i) {
      list10.push(list[i]);
    }
  }
  return list10;
}

export default List;
